export default "__VITE_ASSET__Cvvkt8J0__"